import {gql} from 'apollo-angular';
import {StatusFragment} from "../queries/fragments/Status";

export const EDIT_CLASS = gql`
  mutation EditClass($schoolClassID: Int!, $formData: InSchoolClass!) {
    updateSchoolClass(schoolClassID: $schoolClassID, data: $formData) {
      type,
      message
    }
  }
`;
